import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import { nbPerPageLabel, SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import { getLabel, getObjectLabel } from '../../../../utils/StoreUtils'
import { getFullDate } from '../../../../utils/DateUtil'
import { getQualifications, getStatuses, UNQUALIFIED } from '../../../../utils/QualityUtils'
import { getMeasureStatusColorTable } from '../../../../utils/PiezometryUtils'
import { getSandreIndexLabel } from '../../../../utils/StringUtil'
import { CardTable } from '../../../../components/datatable/NewTable'
import { IS_INITIAL_POINT } from '../../../../station/constants/StationConstants'
import { POINT, WINDOW } from '../constants/PluvioValidationConstants'

const TABLE_HEADERS = ['date', 'value', 'initialValue', 'status', 'qualification', 'nature', 'producer', 'initialPoint']

const TableViewValidationPluvioMode = ({
    selection,
    selectionData,
    setSelectionData,
    measuresData,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setValue,
    setInitialPoint,
}) => {
    const {
        contributorsIndex,
        sandreIndex,
    } = useSelector(store => ({
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        sandreIndex: store.ReferencialReducer.sandreIndex,
    }), shallowEqual)

    const measuresBrut = measuresData[0]?.measures || []
    const qualifications = getQualifications()
    const statuses = getStatuses()

    const tableMeasures = measuresBrut.map(d => {
        const color = (d.date >= startDate && d.date <= endDate) ? '#7fdde9' : 'white'
        return {
            measure: d,
            date: { value: getFullDate(d.date), color },
            qualification: { value: getLabel(qualifications, d.qualification || UNQUALIFIED), color },
            status: { value: getLabel(statuses, d.status), color: getMeasureStatusColorTable(d.status) },
            initialPoint: { value: d.initialPoint === IS_INITIAL_POINT ? i18n.yes : '', color },
            producer: { value: getObjectLabel(contributorsIndex[d.producer], 'mnemonique'), color },
            value: { value: d.value, color },
            initialValue: { value: d.initialValue, color },
            nature: { value: getSandreIndexLabel(sandreIndex, SANDRE.PIEZOMETER_MEASURE_NATURE, d.nature), color },
        }
    })

    const selectPoint = (point) => {
        if (!selection || !tableMeasures.length) {
            return
        }
        const { date } = point
        if (selection === WINDOW) {
            if (selectionData === 'end') {
                setSelectionData('start')
                setStartDate(date)
            } else if (selectionData === 'start') {
                if (date < startDate) {
                    setStartDate(date)
                    setEndDate(startDate)
                } else {
                    setSelectionData(null)
                    setEndDate(date)
                }
            }
        } else if (selection === POINT) {
            setStartDate(date)
            setEndDate(date)
            setValue(point.value)
            setInitialPoint(point.initialPoint)
        }
    }

    return (
        <CardTable
            title={i18n.measures}
            rows={tableMeasures}
            headers={TABLE_HEADERS}
            rowsPerPageOptions={nbPerPageLabel}
            onClickRow={m => selectPoint(m.measure)}
            defaultSort={{ column: 'date', direction: 'desc' }}
        />
    )
}

TableViewValidationPluvioMode.propTypes = {
    selection: PropTypes.string,
    selectionData: PropTypes.string,
    setSelectionData: PropTypes.func,
    measuresData: PropTypes.arrayOf(PropTypes.shape({
        measures: PropTypes.arrayOf(PropTypes.shape({})),
    })),
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    setStartDate: PropTypes.func,
    setEndDate: PropTypes.func,
    setValue: PropTypes.func,
    setInitialPoint: PropTypes.func,
}

export default TableViewValidationPluvioMode
